import { Spin, Card } from 'antd';
import { ReactNode } from 'react';

const OrderTabGrid = ({ children }: { children: ReactNode }) => {
    return (
        <div
            className="d-grid w-100 pt-4 gap-3"
            style={{
                gridTemplateColumns: 'repeat(auto-fill, minmax(22em, 1fr))',
            }}
        >
            {children}
        </div>
    );
};

const OrderTab = ({
    children,
    isLoading,
}: {
    children?: ReactNode;
    isLoading: boolean;
}) => {
    return (
        <Spin spinning={isLoading}>
            <Card className="p-5 pt-2 shadow mb-5 bg-white">{children}</Card>
        </Spin>
    );
};

export { OrderTab, OrderTabGrid };
